var fetchApi;
if (typeof fetch === 'function') {
  if (typeof global !== 'undefined' && global.fetch) {
    fetchApi = global.fetch;
  } else if (typeof window !== 'undefined' && window.fetch) {
    fetchApi = window.fetch;
  } else {
    fetchApi = fetch;
  }
}
if (typeof require !== 'undefined' && typeof window === 'undefined') {
  var f = fetchApi || require('cross-fetch');
  if (f.default) f = f.default;
  exports.default = f;
  module.exports = exports.default;
}